<div class="contenedor-post">
  <div class="blog">
    <div class="cabecera-blog">
      <img [src]="post().foto" [alt]="post()?.nombre_blog" width="125" height="125" />
      <h1>
        <a [routerLink]="['/blogs', post()?.nombre_blog | kebabCase]">{{ post()?.nombre_blog }}</a>
      </h1>
      <h4>Por {{ post()?.nombre_autor }}</h4>
    </div>
  </div>

  <h1 class="titulo-post">{{ post()?.tituloVideo }}</h1>
  <div class="img-autor" *ngIf="!post()?.urlVideo && post()?.urlGenerica">
    <app-skeleton-image [created]="post()?.fechaCreacion" [size]="980" [aspectRatio]="'980 / 555'" [src]="post()?.urlGenerica" [lazy]="false"></app-skeleton-image>
  </div>
  <app-video-noticia *ngIf="post()?.urlVideo" [noticia]="post()"></app-video-noticia>
  <hr />
  <div class="description-post" [innerHTML]="post()?.descripcionVideo"></div>
</div>
